import { render, staticRenderFns } from "./previewContent.vue?vue&type=template&id=ec1b98c8&scoped=true&"
import script from "./previewContent.vue?vue&type=script&lang=ts&"
export * from "./previewContent.vue?vue&type=script&lang=ts&"
import style0 from "./previewContent.vue?vue&type=style&index=0&id=ec1b98c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1b98c8",
  null
  
)

export default component.exports